<template>
  <div class="pro-ger">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cabecalho">
        <App-Filtros
        :cpntMontarCampoF="proGerTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="proGerTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="proGerTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'id_con_nome', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='proGerTabBuscarLinhas'
        ref="filtros">
          <div class="botao" v-if="cpntSelecionar === null">
            <App-Button :data-time="time" 
              :cpntId='botao.id'
              :cpntStatus='botao.status' 
              :cpntIcone='botao.icone'
              :cpntTexto='botao.texto'
              :cpntClass='botao.class'
              :cpntDisabled="botao.disabled"
              @onClick='botao.onClick'
            ></App-Button>
          </div>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntSetarFiltros="proGerTabSetarFiltros"
        :cpntMontarFiltros="proGerTabMontarFiltros"
        :cpntMontarWhere="proGerTabTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntMostrarMper="cpntSelecionar === null"
        :cpntApiTabPerFiltros="true"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntApiTabPer="tabper"
        :cpntBotaoExportar="cpntSelecionar === null ? exportar : undefined"
        :cpntBotaoExcluir="cpntSelecionar === null ? botaoExcluir : undefined"
        :cpntBotaoEditar="cpntSelecionar === null ? botaoEditar : undefined"
        :cpntSetarValores="proGerTabSetarLinhas"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiOrder="order"
        :cpntApiField="field"
        :cpntApiFieldVirtual="fieldVir"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='proGerTabMarcarCheckbox'
        ref="tabela">
          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_last="{ linha }">
            <span v-html="linha.last_user_usuario + '<br/>' + linha.last_at_ptbr"></span>
          </template>

          <!-- COLUNA CONTATO -->
          <template v-slot:col_nome="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { proGerTabAbrirCadastro(linha.id_con) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.id_con_nome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='linha.id_con_pessoa === "j" && linha.id_con_empresa !== ""' v-html="' (' + linha.id_con_empresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.id_con_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>
          </template>

          <!-- COLUNA CONTATO -->
          <template v-slot:col_qtde_pro="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" @onClick='() => { proGerTabAbrirRelatorio(linha.id_con, "produto") }'>
              <span v-html="linha._qtde_pro"></span>
            </App-Button>
          </template>

          <!-- COLUNA CONTATO -->
          <template v-slot:col_qtde_ser="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" @onClick='() => { proGerTabAbrirRelatorio(linha.id_con, "servico") }'>
              <span v-html="linha._qtde_ser"></span>
            </App-Button>
          </template>

          <!-- SETA PARA SELECIONAR O REGISTRO -->
          <template v-slot:col_selecionar="{ linha, indexL }">
            <App-Button @onClick='() => { cpntSelecionar(linha, indexL) }' :cpntClass="'btn btn-primary btn-sm'" :cpntIcone="'selecionar'"></App-Button>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view v-if="cpntSelecionar === null" :cpntFecharFormulario="proGerTabFecharFormulario"></router-view>

    <!-- ABRE O RELATORIO DE CONFIGURAÇÕES SOLICITADO -->
    <App-Comissoes-Config-Lista-Configuracoes v-if="relatorio !== null"
    :cpntId="relatorio.id"
    :cpntTipo="relatorio.tipo"
    :cpntFecharFormulario="proGerTabFecharRelatorio"
    ></App-Comissoes-Config-Lista-Configuracoes>
  </div>
</template>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntSelecionar: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'App-Comissoes-Config-Lista-Configuracoes': () => import('@/components/comissoes/config/Comissoes-Config-Lista-Configuracoes.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        conferencia: [],
        tabper: 'CmsCfgCom',
        route: '/comissao/config/comissionado/get',
        botao: {
          status: '',
          texto: 'Novo Vendedor',
          class: [ 'btn', 'btn-info' ],
          mostrar: true,
          onClick: () => { this.$router.push({ name: 'comissao_config_cms_form', params: { id: 0 } }) }
        },
        colunas: [],
        linha: [],
        fazerOrdenacao: true,
        tabPerOrder: [
          { id: '0', nome: 'Última Alteração',      chave: 'last_at',    order: 'desc' },
          { id: '1', nome: 'Código Crescente',      chave: 'id_con',        order: 'asc' },
          { id: '2', nome: 'Ordem Alfabética',      chave: 'id_con_nome',   order: 'asc' },
          { id: '3', nome: 'Código Decrescente',    chave: 'id_con',        order: 'desc' }
        ],  
        field: {},
        fieldVir: [],
        where: {},
        order: {},
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        botaoEditar: undefined,
        botaoExcluir: undefined,
        botaoReativar: undefined,
        botaoQtdeTotalEstoque: undefined,
        exportar: undefined,
        qtdeEstoqueTotal: undefined,
        relatorio: null
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.proGerTabSetarStatusGeral('carregando')

      // FAZ A BUSCA DAS LINHAS NA TABELA
      this.proGerTabBuscarLinhas()
    },
    methods: {
      proGerTabFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.proGerTabBuscarLinhas()
        }
      },
      proGerTabFecharRelatorio: function () {
        // SETA O STATUS DA TELA
        this.relatorio = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proGerTabAbrirRelatorio: function (id_con, tipo) {
        // SETA O STATUS DA TELA
        this.relatorio = { id: id_con, tipo: tipo }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proGerTabBuscarLinhas: function () {
        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar =  this.proGerTabEditar
        this.botaoExcluir = this.proGerTabExcluir
        this.exportar = null

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

        // SETA OS PARAMETROS PARA EXPORTAÇÃO
        this.exportar = {
          format: [ 'xlsx', 'pdf' ],
          search: true,
          field: [  
            { id_con:                                   'Código.'                                   },
            { id_con_nome:                              'Vendedor'                                  },
            { virtual_qtde_total_produto:               'Qtde. Total Produtos'                      },
            { virtual_qtde_total_produto_configurado:   'Qtde. Produtos Comissionados'              },
            { virtual_qtde_total_servico:               'Qtde. Total Serviços'                      },
            { virtual_qtde_total_servico_configurado:   'Qtde. Serviços Comissionados'              },
            { cod_barra:                                'Cód. Barra'                                }
          ]
        }

        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3,    chave: 'id_con',                                          tipo: 'checkbox'  },
          { mPer: 1,    chave: 'id_con',        nome: 'Cód.'                                        },
          { mPer: 2,    chave: 'nome',          nome: 'Nome'                                        },
          { mPer: 1,    chave: 'qtde_pro',      nome: 'Qtde Produto Comissionado'                   },
          { mPer: 1,    chave: 'qtde_ser',      nome: 'Qtde Serviço Comissionado'                   },
          { mPer: 1,    chave: 'last',          nome: 'Última Alteração'                            }
        ]

        // SETA OS CAMPOS QUE DEVE BUSCAR
        this.field = {
          id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } },
          last_user: { j: { usuario: null } },
          last_at: null
        }

        // SETA OS CAMPOS VIRTUAIS QUE DEVE BUSCAR
        this.fieldVir = []

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []
        
        //REMOVE A COLUNA SE NÃO TIVER PERMISSÃO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === false) {
          remover.push('qtde_pro')
        } else {
          this.fieldVir = this.fieldVir.concat([ 'qtde_total_produto', 'qtde_total_produto_configurado' ])
        }
        
        //REMOVE A COLUNA SE NÃO TIVER PERMISSÃO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, null, null, false) === false) {
          remover.push('qtde_ser')
        } else {
          this.fieldVir = this.fieldVir.concat([ 'qtde_total_servico', 'qtde_total_servico_configurado' ])
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if ([ '', null, undefined ].indexOf(this.cpntSelecionar) === -1) {
          // ADICIONA O VALOR QUE NÃO DEVE COLOCAR ORDENAÇÃO MPER
          this.estruturaQueryGet[0].push('sem_order_mper')

          // LIMPA A ORDENAÇÃO DA TABELA
          this.order = { last_at: 'desc' }

          // REMOVE AS COLUNAS QUE NÃO PODEM SER COPAIDAS
          remover = remover.concat([ 'id_con' ])

          // CRIA UMA NOVA COLUNA PARA SELECIONAR
          colunas.unshift({ mPer: 3, chave: 'selecionar', nome: 'Selecionar' })
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && this.statusGeral === '') {
          this.proGerTabReiniciar()
        } else {
          this.proGerTabSetarStatusGeral('')
        }
      },
      proGerTabAbrirCadastro: function (id) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: 'contato', id: id }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.proGerTabBuscarLinhas()
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      proGerTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}

        // FAZ A QUEBRA DE SINCRONIMOS DO VUE
        where = JSON.parse(JSON.stringify(where))
        
        // CONVERTE A OPERAÇÃO RECEBIDA
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'id_con_nome':
            if (where.o === '=') {
              retorno.where = { f: 'id', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { m: 'contato', f: 'nome' })
            }
            break

          case 'id_con_cnpj':
          case 'id_con_cpf':
            retorno.where = { m: 'contato', f: 'cnpj_cpf', o: where.o, v: where.v }
            break

          case 'id_con_telefone':
            retorno.where = { aOr: [
              { m: 'contato', f: 'tel_res', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_com', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_cel', o: where.o, v: where.v }
            ] }
            break

          case 'id_con_email':
            retorno.where = { m: 'contato', f: 'email', o: where.o, v: where.v }
            break

          case 'id_con_estado':
            retorno.where = { m: 'contato', f: 'id_estado', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_cidade':
            retorno.where = { m: 'contato', f: 'id_cidade', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_tp_con':
            retorno.where = { m: 'contato', f: 'id_tp_con', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_pessoa':
            retorno.where = { m: 'contato', f: 'pessoa', o: where.o, v: where.v }
            break

          case 'busca':
            // SETA OS DADOS QUE DEVE BUSCAR
            retorno.where = { o: 's.ft', v: where.v }

            // REINICIA O VALOR DO CAMPO
            this.fazerOrdenacao = false
            break
        }

        // SETA O FLAG DO CAMPO
        retorno.fazerOrdenacao = this.fazerOrdenacao

        // RETORNA O VALOR MONTADO
        return retorno
      },
      proGerTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proGerTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.proGerTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      proGerTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            // VERIFICA SE TEM QUE ALTERAR O FILTRO DO CAMPO
            if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1 && ([ '', null, undefined ].indexOf(filtros) !== -1 || (Array.isArray(filtros) === true && filtros.length === 0))) {
              filtros = this.cpntFiltros
            }

            // SETA O FILTRO NA TELA
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.proGerTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      proGerTabMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.proGerTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      proGerTabSetarLinhas: function (vetor) {
        // TRATA OS VALORES RECEBIDOS
        for (var index in vetor) {
          // SETA A VARIAVEL DE QUANTIDADE
          vetor[index]._qtde_pro = vetor[index].virtual_qtde_total_produto_configurado + '/' + vetor[index].virtual_qtde_total_produto
          vetor[index]._qtde_ser = vetor[index].virtual_qtde_total_servico_configurado + '/' + vetor[index].virtual_qtde_total_servico
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proGerTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proGerTabEditar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else {
          // SETA OS IDS QUE DEVE EDITAR
          var ids = this.checkbox.length === 1 ? this.checkbox[0] : window.btoa(JSON.stringify(this.checkbox))

          // REDIRENCIONA PARA TELA SOLICITADA
          this.$router.push({ name: 'comissao_config_cms_form', params: { id: ids } })
        }
      },
      proGerTabExcluir: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente excluir o(s) vendedores(s) selecionado(s)?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: this.checkbox }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/comissao/config/comissionado', 'DELETE', formData, (apiSuccess) => {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // MANDA ATUALIZAR A TABELA
            this.proGerTabBuscarLinhas()

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.proGerTabExcluir

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.proGerTabSetarStatusGeral)
        }
      },
      proGerTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { slot: 'contato', mask: 'id_con' }
        ]

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      proGerTabOnBuscarOptionsFiltroO: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var seletor = {}
        
        // RETORNA O VALOR MONTADO
        callback(seletor)
      },
      proGerTabOnBuscarOptionsFiltroV: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var seletor = {}

        // RETORNA O VALOR MONTADO
        callback(seletor)
      }
    },
    watch: {
      '$route': function (routeAtual, routeAnterior) {
        if (routeAnterior.name !== 'comissao_config_cms_form' && routeAtual.name !== 'comissao_config_cms_form') {
          // SETA O STATUS DA PAGINA
          this.proGerTabSetarStatusGeral('carregando')

          // LIMPA OS VALORES PARA NÃO APRESENTAR ERRADO
          this.checkbox = []
          this.where = {}
          this.linha = []
          this.colunas = []

          // MANDA ATUALIZAR A TABELA
          setTimeout(() => { this.proGerTabBuscarLinhas() }, 500)
        }
      }
    }
  }
</script>
